import { Component, OnInit } from '@angular/core';
import { PujaPrasadMaster } from './../puja-prasad-master';
import { PujaPrasadService } from "./../puja-prasad.service";
import { PujaPrasadOrderService } from "./../puja-prasad-order.service";
import { SharedService } from "./../../shared/shared.service";
import { DevoteeDetail } from '../../Devotee/devotee-detail';

@Component({
  selector: 'app-puja-prasad',
  templateUrl: './puja-prasad.component.html',
  styleUrls: ['./puja-prasad.component.css'],
  providers: [PujaPrasadService, PujaPrasadOrderService]
})
export class PujaPrasadComponent implements OnInit {

  constructor(
    private sharedService: SharedService,
    private pujaPrasadService: PujaPrasadService) { }

  pujaPrasadList: PujaPrasadMaster[] = [];
  devoteeCarts: PujaPrasadMaster[] = [];
  devoteeDetail: DevoteeDetail;
  totalCartAmount: number = 0;
  successMessage: string;
  errorMessage: string;
  pujaPrasadErrMsg: { [key: number]: string } = {};

  prasadStatusList: string[] = [
    "Prasad Requested",
    "Payment Sucessful",
    "Puja Performed",
    "Prasad Dispatched",
    "Prasad Recived"
  ]

  ngOnInit() {
    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();

    this.devoteeCarts = this.sharedService.getDevoteeCartDataAtLocStorage();
    this.calculateTotalCartAmount();


    this.loadPujaPrasadList();
    this.pujaPrasadErrMsg = {};
  }



  private loadPujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadService.getPujaDetails().subscribe(
      data => {
        this.pujaPrasadList = data;
        this.sharedService.hideSpinner();
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      }
    )
  }

  public addToCart(pujaPrasad: PujaPrasadMaster): void {
    // if prasad already added then don't add it again and show message already added to cart
    if (this.devoteeCarts.find(x => x.PujaVidhiNo == pujaPrasad.PujaVidhiNo) != undefined) {
      this.errorMessage = "Puja already added to cart";
      this.pujaPrasadErrMsg[pujaPrasad.PujaVidhiNo] = this.errorMessage;
      return;
    }

    this.devoteeCarts.push(pujaPrasad);
    this.sharedService.setDevoteeCartDataAtLocStorage(this.devoteeCarts);
    this.calculateTotalCartAmount();
  }

  public removeFromCart(pujaPrasad: PujaPrasadMaster): void {
    let index = this.devoteeCarts.indexOf(pujaPrasad);
    if (index >= 0) {
      this.devoteeCarts.splice(index, 1);
      this.sharedService.setDevoteeCartDataAtLocStorage(this.devoteeCarts);
      this.calculateTotalCartAmount();
    }
  }

  public calculateTotalCartAmount() {
    let totalAmount = 0;
    this.devoteeCarts.forEach(x => totalAmount += x.Amount);
    this.totalCartAmount = totalAmount;
  }

  getPujaPrasadName(pujaId: number) {
    let pujaPrasad: PujaPrasadMaster = this.pujaPrasadList.find(x => x.Id == pujaId);
    if (pujaPrasad !== undefined) {
      return pujaPrasad.TypeOfPuja;
    }

    return "";
  }

  checkPrasadStatusComplete(currentStatus: string, index: number): boolean {
    let indexOf = 0;
    console.log(currentStatus.indexOf("Payment Under Verification"));
    if (currentStatus.indexOf("Payment Under Verification") >= 0) {
      indexOf = 0;
    } else if (currentStatus.indexOf("Payment Failed") >= 0) {
      indexOf = 0;
    } else {
      indexOf = this.prasadStatusList.indexOf(currentStatus);
    }

    return (indexOf >= index);
  }

  public bookPujaPrasad(id: number) {

  }

}



// WEBPACK FOOTER //
// ./src/app/prasad-order/puja-prasad/puja-prasad.component.ts